export default __webpack_public_path__ + "static/media/waving-hand.82c4080b.png";